import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export interface GetImageComponentImageParams {
    widgetId: number;
}

export const useQueryImageComponentDownloadImage = (params: GetImageComponentImageParams, endpoint?: string) => {
    return useQuery<Blob, QueryError>(
        ['imageComponentDownloadImage', params],
        () =>
            queryFn(params, `${endpoint}?widgetId=${params.widgetId}`, {
                responseType: 'blob',
            }),
        {
            enabled: Boolean(params.widgetId) && params.widgetId > 0 && Boolean(endpoint),
        },
    );
};
